<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('menuOrganization.branchType') }}</label>
                    <v-select class="" v-model="types" :clearable="false"
                              :options="branchTypeOptions" :reduce="(option) => option.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('button.search') }}</label>
                    <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên ..."
                              @keyup.enter="filter"></vs-input>
                </div>
                <div class="vx-col lg:w-1/2 md:w-1/3 full">
                    <div class="flex mt-6">
                        <vs-button class="" icon-pack="feather" icon="icon-search" @click="filter">
                            {{ $t('button.search') }}
                        </vs-button>
                        <vs-button
                            class="ml-auto"
                            v-show="isPermission()"
                            @click="addCamera"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus">
                            {{ $t('menuOrganization.addBranch') }}
                        </vs-button>
                    </div>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="organizationBranchList"
                         :animateRows="true"
                         :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         :pagination="true"
                         :modules="modules"
                         :autoGroupColumnDef="autoGroupColumnDef"
                         :getDataPath="getDataPath"
                         :treeData="true"
                         :groupDefaultExpanded="groupDefaultExpanded"
                         :paginationPageSize="pageSize"
                         @pagination-changed="onPaginationChanged"
            >
            </ag-grid-vue>

            <div class="vx-row" v-if="organizationBranchList && organizationBranchList.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        organizationBranchList.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : organizationBranchList.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import {constRouter} from "../../../store/constant.js";
import {isRouter} from "../../../store/permission";
import vSelect from 'vue-select';
import moment from "moment";
import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import {RowGroupingModule} from "@ag-grid-enterprise/row-grouping";

export default {
    components: {
        AgGridVue,
        CellRendererActions,
        vSelect,
    },
    data() {
        return {
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                // {
                //     headerName: 'STT',
                //     field: 'stt',
                //     width: 100
                // },
                // {
                //     headerName: this.$t('menuOrganization.branchName'),
                //     field: 'organizationBranchName',
                //     width: 250
                // },
                {
                    headerName: this.$t('menuOrganization.phoneNumber'),
                    field: 'phoneNumber',
                    width: 170,
                },
                {
                    headerName: this.$t('menuOrganization.address'),
                    field: 'fullAddress',
                    width: 350
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            organizationBranchList: [],
            isShow: false,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
            branchTypeOptions: [
                {label: this.$t('menuOrganization.all'), value: null},
                {label: this.$t('menuOrganization.null'), value: 0},
                {label: this.$t('menuOrganization.principalOffice'), value: 1},
                {label: this.$t('menuOrganization.branch'), value: 2},
                // {label: this.$t('menuOrganization.client'), value: 3},
            ],
            types: null,
            keySearch: null,
            pageNumber: 0,
            pageSize: 20,
            modules: [ClientSideRowModelModule, RowGroupingModule],
            autoGroupColumnDef: null,
            groupDefaultExpanded: null,
            getDataPath: null,

        }
    },
    async created() {
        await this.getOrganizationBranch();
        this.autoGroupColumnDef = {
            headerName: this.$t('menuOrganization.branchName'),
            minWidth: 300,
            field: 'organizationBranchName',
            cellRendererParams: {suppressCount: true},
        };
        this.groupDefaultExpanded = -1;
        this.getDataPath = (data) => {
            return data.patchTmp;
        };
        console.log(this.getDataPath)
    },
    watch: {
        '$store.state.deleteBranchStatus'(val) {
            if (val) {
                this.filter();
                this.$store.commit('DELETE_BRANCH_STATUS', false);
            }
        },
    },

    methods: {
        isPermission() {
            return isRouter(this, constRouter.organization_branch_add);
        },
        addCamera() {
            this.$router.push(constRouter.organization_branch_add).catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        getOrganizationBranch() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/organization-branch/all').then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.organizationBranchList = res.data.filter(x => x.organizationBranchType !== 3).map(x => {
                            x.stt = this.pageSize * this.pageNumber + res.data.indexOf(x) + 1;
                            x.createdDateStr = x.createdDate ? moment(x.createdDate).format('DD/MM/YYYY') : null;
                            x.modifiedDateStr = x.modifiedDate ? moment(x.modifiedDate).format('DD/MM/YYYY') : null;
                            x.patchTmp = x.patch.split('/').map(t => parseInt(t))
                            return x;
                        });
                    } else {
                        this.organizationBranchList = [];
                    }
                    // this.totalPages = res.data.totalPages;
                    this.totalElements = res.data.length;
                    resolve(res)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },

        changePageSize(number) {
            // this.pageSize = number;
            // this.filter();
            this.pageSize = number
            this.loadPage(1)
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getOrganizationBranch();
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
